import React from 'react';
import {useRouteMatch, Route, Redirect, Switch} from 'react-router-dom';
import {Nav, Container, Spinner} from 'react-bootstrap';
import {observer} from 'mobx-react-lite';
import CertificateProgress from './InProgress';
import {NavItem, Link, Tab, CertificateFinishAssessment} from '../elements/style';
import {useStore} from '../../../store';
import CertificateQuestions from '../../Video/components/Certificate';
import CertificateCompleted from './Completed';

const CertificateTab = observer(() => {
  const match = useRouteMatch();
  const {certificateStore} = useStore();
  const {
    question,
    cmeLoading,
    videoTitle,
    showQuestionBlock,
    showQuestions,
    inProgressTotalCount,
    completedTotalCount,
  } = certificateStore;
  return (
    <>
      <Tab
        onClick={() => (question ? showQuestions(false) : '')}
        onKeyDown={() => (question ? showQuestions(false) : '')}
        aria-hidden="true"
      >
        <Container>
          <Nav defaultActiveKey={`${match.url}/in-progress`}>
            <NavItem className="nav-item">
              <Link className="nav-link a_showDashboard" activeClassName="active" to={`${match.url}/in-progress`}>
                {inProgressTotalCount}&nbsp; In Progress
              </Link>
            </NavItem>
            <NavItem className="nav-item">
              <Link className="nav-link" activeClassName="active" to={`${match.url}/completed`}>
                {completedTotalCount}&nbsp; Completed
              </Link>
            </NavItem>
          </Nav>
        </Container>
      </Tab>
      <div className="w-100 position-relative" id="cme-contents">
        <Switch>
          <Route exact path={`${match.path}/in-progress`} render={() => <CertificateProgress />} />
          <Route exact path={`${match.path}/completed`} render={() => <CertificateCompleted />} />
          <Redirect to={`${match.path}/in-progress`} />
        </Switch>
        {question && showQuestionBlock && window.innerWidth < 768 ? (
          <CertificateFinishAssessment className="in-progress-assessment">
            {cmeLoading ? (
              <div className="spinner-wrapper w-100 h-100 d-flex align-items-center justify-content-center">
                <Spinner animation="grow" role="status" variant="secondary">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </div>
            ) : (
              <CertificateQuestions expanded={question} title="Certificate Assessment" videoTitle={videoTitle} />
            )}
          </CertificateFinishAssessment>
        ) : (
          ''
        )}
      </div>
    </>
  );
});

export default CertificateTab;
